/**
 * PDF生成APIレスポンス型定義（OpenAPI仕様準拠）
 *
 * このファイルは最新のAPI定義（OpenAPI 3.0.3）に基づいています。
 * 参照: /api/v1/pdf/resume/generate/ エンドポイント
 */

import type { ApiErrorResponse, ApiSuccessResponse } from './common';

/**
 * PDF生成成功レスポンス
 */
export type PdfGenerateSuccessResponse = ApiSuccessResponse<{
  /** PDF取得用トークン */
  token: string;
  /** トークン有効期限（ISO形式） */
  expiresAt: string;
  /** PDFダウンロードURL */
  downloadUrl: string;
  /** 推定ファイルサイズ（KB）（オプション） */
  estimatedSizeKB?: number;
}>;

/**
 * PDF生成APIレスポンスの統合型
 */
export type PdfGenerateApiResponse = PdfGenerateSuccessResponse | ApiErrorResponse;

/**
 * レスポンスの型ガード関数
 */
export function isPdfGenerateSuccess(
  response: PdfGenerateApiResponse
): response is PdfGenerateSuccessResponse {
  return response.success === true;
}
